// The drive's front door. Without a session it is the sign-in card; with one it is the drive.
import PropTypes from 'prop-types'

import AccountsSignIn from '../auth/AccountsSignIn'
import MyDrive, {SECTIONS} from './MyDrive'

import useSession from '../../lib/hooks/useSession'

const DriveContainer = ({section = 'drive'}) => {
  const {authToken} = useSession()

  // What ends a session is the token going away — a renewal the server refused clears it — and
  // that reaches this render as the sign-in card without anything here having to ask.
  return authToken ? <MyDrive section={section} /> : <AccountsSignIn />
}

DriveContainer.propTypes = {
  section: PropTypes.oneOf(SECTIONS)
}

export default DriveContainer
